export class MovingSuppliesItem {
  label: string;
  _$visited?: any;

  constructor(label?: string) {
    if (label != null)
      this.label = label;
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/movingSuppliesItem.ts